import { useQuery } from "@tanstack/react-query";
import { Lock, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

const Row = ({ ok, label, detail, testid }) => (
  <div className="flex items-start gap-2 text-sm" data-testid={testid}>
    {ok ? <CheckCircle2 className="mt-0.5 h-4 w-4 text-emerald-600" /> : <Lock className="mt-0.5 h-4 w-4 text-slate-400" />}
    <div><b>{label}</b> <span className="text-slate-600">{detail}</span></div>
  </div>
);

export const ShallyPlanCard = ({ focus }) => {
  const q = useQuery({ queryKey: ["shally-ent"], queryFn: async () => (await api.get("/shally/entitlements")).data, retry: false });
  const e = q.data;
  if (q.isLoading) return <p className="text-xs text-slate-500" data-testid="shally-plan-loading">Loading your Shally plan…</p>;
  if (!e) return <p className="text-xs text-rose-700" data-testid="shally-plan-error">Could not load your Shally plan status.</p>;
  const inb = e.inbound, ob = e.outbound;
  return (
    <div className="space-y-2 rounded-xl border bg-white p-3" data-testid="shally-plan-card">
      <Row ok={inb.ok} testid="ent-inbound" label="AI Inbound Receptionist:"
        detail={inb.ok ? `${inb.status}${inb.minutes_remaining != null ? `, ${inb.minutes_remaining} min left` : ""}${inb.period_end ? `, until ${inb.period_end.slice(0, 10)}` : ""}` : (inb.reason || "Not active")} />
      <Row ok={ob.ok} testid="ent-outbound" label="AI Outbound Calling:"
        detail={ob.ok ? `pay as you use, paid credit ₹${(ob.paid_paise / 100).toFixed(0)}, promotional ₹${(ob.promo_paise / 100).toFixed(0)}${ob.trial_active && ob.period_end ? ` (trial until ${ob.period_end.slice(0, 10)})` : ""}` : (ob.reason || "Locked")} />
      {focus === "outbound" && ob.blocked?.length > 0 && <p className="text-xs text-slate-600" data-testid="ent-ob-blocked">Real calls blocked: {ob.blocked.length} requirement(s) pending. See the compliance checklist below.</p>}
      {e.branches?.length > 1 && <div className="text-xs text-slate-600" data-testid="ent-branches">{e.branches.map((b) => <div key={b.branch_id}>{b.name}: {b.inbound_ok ? "inbound active" : "inbound locked"}{b.number_last4 ? `, number …${b.number_last4}${b.number_live ? " (live)" : ""}` : ", no number"}</div>)}</div>}
      <p className="text-xs text-slate-500" data-testid="ent-kyc">KYC: {e.kyc.status.replaceAll("_", " ")}{e.kyc.simulated ? " (SIMULATED)" : ""}. {e.note}</p>
    </div>
  );
};
